import React, { useRef } from 'react';
import { Link, Switch, Route, useHistory, useRouteMatch, useLocation } from 'react-router-dom';
import { css, StyleSheet } from 'aphrodite/no-important';
import {
  TabsContainer,
  TabItem
} from 'quantux-ui';
import { gray, blue } from '../../theme';
import { Placeholder } from '../placeholder';
import CasesDataGrid from './cases-data-grid';
import CasesIcon from '../svg-icons/cases-icon';

// const Cases = <Placeholder text='Cases placeholder' />;
// const Payments = <Placeholder text='Payments placeholder' />;

const tabsTextStyles = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
};

const RevenueCycleManagement = (props) => {
  const tabsContainer = useRef();

  const history = useHistory();
  const location = useLocation();
  const { pathname } = location;
  const { path, url } = useRouteMatch();
  console.log('Revenue Cycle Mangement');
  console.log(`pathname = ${pathname}`);
  console.log(`path = ${path}`);

  const styles = StyleSheet.create({
    tabs: {
      height: '100%',
      padding: '0 8px',
      marginLeft: '8px'
    },
    tabDetail: {
      height: '100%'
    },
    linkStyles: {
      color: gray[300],
      ':visited': {
        color: gray[300]
      }
    },
    selectedLink: {
      color: blue[500]
    }
  });

  return (
    <div
      ref={tabsContainer}
      className={css(styles.tabs)}
    >
      <TabsContainer
        dropDownId="d1"
        showPlusIcon={false}
        isDrawer={false}
        shiftMethod='availableWidth'
        containerWidth={tabsContainer && tabsContainer.current ? tabsContainer.current.getBoundingClientRect().width : 610}
        otherElementsWidth={320}
        minWidth={610}
        dropDownTop={39}
        dropDownLeft={44}
        dropDownHeaderStyles={{
          // minWidth: '170px',
          // maxWidth: '370px',
          // width: '100%'
        }}
        containerStyles={{
          // width: `calc(100% - ${drawerWidth}px)`
          width: '100%'
        }}
      >
        <TabItem
          tabKey="1"
          key='cases'
          parentKey="0111"
          text="Cases"
          isActive={
            pathname === '/user//revenue/cases' ||
            pathname === '/user//revenue' ||
            pathname.endsWith('/cases') ||
            pathname.endsWith('/revenue')
          }
          showSvgIcon
          svgIcon={CasesIcon}
          style={{
            width: '80px',
            minWidth: '80px',
            maxWidth: '80px'
          }}
          textStyles={tabsTextStyles}
          onActivate={() => {
            history.push(`${url}/cases`);
          }}
        >
          <Link
            to={`${url}/about`}
            className={css(
              styles.tabText,
              styles.linkStyles,
              pathname === '/user/about' && styles.selectedLink
            )}
          >
            Cases
          </Link>
        </TabItem>
        <TabItem
          tabKey="2"
          key='payments'
          parentKey="0111"
          text="Payments"
          isActive={pathname.endsWith('/payments')}
          iconClass='fa fa-usd'
          style={{
            width: '105px',
            minWidth: '105px',
            maxWidth: '105px'
          }}
          textStyles={tabsTextStyles}
          onActivate={() => {
            history.push(`${url}/payments`);
          }}
        >
          <Link
            to={`${url}/payments`}
            className={css(
              styles.linkStyles,
              pathname.endsWith('/payments') && styles.selectedLink
            )}
          >
            Payments
          </Link>
        </TabItem>
      </TabsContainer>
      {/* Active tab component */}
      <div className={css(styles.tabDetail)}>
        <Switch>
          <Route exact path={path}>
            <CasesDataGrid />
          </Route>
          <Route path={`${path}/cases`}>
            <CasesDataGrid />
          </Route>
          <Route path={`${path}/payments`}>
            <Placeholder text='Payments placeholder' />
          </Route>
        </Switch>
      </div>
    </div>
  );
};

export default RevenueCycleManagement;
